import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyDKMjzGbMUv-mnoqcK1IkRbkVpX-ImfplI",
    authDomain: "monitor-academico.firebaseapp.com",
    projectId: "monitor-academico",
    storageBucket: "monitor-academico.firebasestorage.app",
    messagingSenderId: "130274032266",
    appId: "1:130274032266:web:469d04fc9fc54d817acb73",
    measurementId: "G-5Z3DDH8PKZ"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);